import React from 'react';
import { getOptions } from '../../Thunks/Queries.ts';
import { useAppDispatch, useAppSelector } from '../../Store/store.ts';
import { TranslationsSelector } from '../../Selectors/FitAssistantSelectors.ts';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';

const ErrorComponent = () => {
  const dispatch = useAppDispatch();
  const translations = useAppSelector(TranslationsSelector);

  const onClickPrimary = () => {
    dispatch(getOptions());
  };

  return (
    <>
      <div>
        <p>{translations.loadingErrorMessage}</p>
      </div>
      <Buttons visible>
        <PrimaryButton visible={true} text={translations.reload} onClick={onClickPrimary} />
      </Buttons>
    </>
  );
};

export default ErrorComponent;
